import { motion } from 'framer-motion';

const HolographicCard = ({ icon: Icon, title, description, delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay }}
      viewport={{ once: true }}
      className="group relative bg-surface border border-border hover:border-primary transition-all duration-300 p-8 overflow-hidden"
      data-testid={`card-${title.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {/* Holographic glow effect */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      {/* Corner accent */}
      <div className="absolute top-0 right-0 w-16 h-16 border-t-2 border-r-2 border-primary opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      
      <div className="relative z-10">
        <div className="flex items-center gap-4 mb-4">
          <div className="p-3 bg-primary/10 border border-primary">
            <Icon className="w-8 h-8 text-primary" />
          </div>
          <h3 className="font-space-mono text-xl font-bold text-white uppercase tracking-wider">
            {title}
          </h3>
        </div>
        <p className="text-text-secondary leading-relaxed font-inter">
          {description}
        </p>
      </div>
      
      {/* Scan line effect on hover */}
      <div className="absolute left-0 right-0 h-24 bg-gradient-to-b from-transparent via-primary/10 to-transparent opacity-0 group-hover:opacity-100 group-hover:animate-scan pointer-events-none"></div>
    </motion.div>
  );
};

export default HolographicCard;
